import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  template: `
    <div class="fixed top-4 left-1/2 -translate-x-1/2 z-10003 flex flex-col items-center gap-2 pointer-events-none">
      @for (toast of toastSvc.toasts(); track toast.id) {
        <div class="pointer-events-auto flex items-center gap-2 px-4 py-3 rounded-xl text-sm font-medium animate-slide-down" style="box-shadow: var(--shadow-lg)"
             [class]="variantClass(toast.variant)">
          @if (toast.icon) {
            <span class="material-symbols-outlined text-lg">{{ toast.icon }}</span>
          }
          <span>{{ toast.message }}</span>
          <button (click)="toastSvc.dismiss(toast.id)"
                  class="ml-2 p-0.5 rounded hover:bg-black/10 transition-colors">
            <span class="material-symbols-outlined text-base">close</span>
          </button>
        </div>
      }
    </div>
  `,
  styles: [`
    @keyframes slide-down {
      from { opacity: 0; transform: translateY(-12px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .animate-slide-down {
      animation: slide-down .25s ease-out;
    }
  `],
})
export class ToastContainer {
  protected readonly toastSvc = inject(ToastService);

  variantClass(variant: string): string {
    switch (variant) {
      case 'success': return 'bg-green-600 text-white';
      case 'error':   return 'bg-red-600 text-white';
      case 'warning': return 'bg-amber-500 text-white';
      case 'info':    return 'bg-blue-600 text-white';
      default:        return 'bg-gray-800 text-white';
    }
  }
}
